import qs from "querystringify";

export function processAPILink(currentRoute, urlParameters = false) {
  return function (link) {
    const { url, ucFrom, ucUpdateCache, showNewWindow } = link;

    const evaluatedURL = urlParameters
      ? evaluateURLTemplate(url, urlParameters)
      : url;

    const href = appendReferrerToURL({
      url: evaluatedURL,
      ucFrom,
      ucUpdateCache,
      currentRoute,
    });

    const target = showNewWindow ? "_blank" : "_self";
    const rel = showNewWindow ? "noopener noreferrer" : null;
    const transformed = {
      disabled: link.disabled,
      title: link.title,
      href,
      url: href,
      target,
      rel,
      "data-testid": "api-link",
      "data-url-id": link.urlId,
    };

    return {
      text: link.name || link.title,
      showNewWindow,
      props: transformed,
    };
  };
}

// Transforms an incoming API link by appending "ucFrom" properties that Campus Solutions expects.
export const appendReferrerToURL = ({
  url,
  ucFrom,
  ucUpdateCache,
  currentRoute,
}) => {
  if (ucFrom) {
    const queryStringPrefix = url.includes("?") ? "&" : true;
    return (
      url +
      qs.stringify(
        {
          ucFrom: "CalCentral",
          ucFromText: currentRoute.name,
          ucFromLink: returnURL(currentRoute.url, ucUpdateCache),
        },
        queryStringPrefix
      )
    );
  }

  return url;
};

// the ucFromLink value may need to have a 'ucUpdateCache' parameter appended to it,
// if we get the value from the Link API the following will append it to the ucFromLink
const returnURL = (url, updateCache) => {
  const queryStringPrefixFromLink = url.includes("?") ? "&" : true;
  return updateCache && !url.includes("ucUpdateCache")
    ? url +
        qs.stringify({ ucUpdateCache: updateCache }, queryStringPrefixFromLink)
    : url;
};

/**
 * Replaces template values in URL string with those provided in urlParameters
 * object.
 *
 * Example
 *    Input:
 *      url: "https://example.com/financial_aid?emplid={EMPLID}&ucAidYear={AID_YEAR}"
 *      urlParameters: { EMPLID: '1234', AID_YEAR: '2025' }
 *    Output:
 *      "https://example.com/financial_aid?emplid=1234&ucAidYear=2025"
 *
 * @param {string} url
 * @param {Object} urlParameters
 * @returns string
 */
export const evaluateURLTemplate = (url, urlParameters) => {
  // create copy to avoid mutation
  let evaluatedURL = url.slice();
  // replace each template value in URL
  for (const parameter in urlParameters) {
    evaluatedURL = evaluatedURL.replaceAll(
      "{" + parameter + "}",
      urlParameters[parameter]
    );
  }
  return evaluatedURL;
};
